import { render } from "./themes-categories-search.vue?vue&type=template&id=2ce71a62"
import script from "./themes-categories-search.vue?vue&type=script&lang=js"
export * from "./themes-categories-search.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__